(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mana-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-close]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
    const menu = document.querySelector('#mana-menu');
    const toggle = document.querySelector('.m-menu-toggle');
    if (menu && toggle && !toggle.dataset.bound) {
      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', () => { menu.showModal(); toggle.setAttribute('aria-expanded','true'); });
      menu.addEventListener('close', () => { toggle.setAttribute('aria-expanded','false'); toggle.focus(); });
      menu.addEventListener('click', event => { if (event.target === menu) { const r = menu.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right) menu.close(); } });
    }
    scope.querySelectorAll('[data-mana-product]').forEach(root => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      const thumbnails = [...root.querySelectorAll('[data-gallery-select]')];
      const chooseImage = (index, focusThumbnail = false) => {
        const button = thumbnails[(index + thumbnails.length) % thumbnails.length];
        if (!button) return;
        root.querySelectorAll('[data-gallery-slide]').forEach(slide => { slide.hidden = slide.dataset.gallerySlide !== button.dataset.gallerySelect; });
        thumbnails.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        const caption = root.querySelector('[data-gallery-caption]');
        const count = root.querySelector('[data-gallery-count]');
        if (caption) caption.textContent = button.getAttribute('aria-label');
        if (count) count.textContent = String(thumbnails.indexOf(button) + 1);
        const rail = button.parentElement;
        rail.scrollTo({left: button.offsetLeft - rail.offsetLeft - (rail.clientWidth - button.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        if (focusThumbnail) button.focus({preventScroll: true});
      };
      thumbnails.forEach((button, index) => {
        button.addEventListener('click', () => chooseImage(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          chooseImage(event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
        const current = thumbnails.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true');
        chooseImage(current + Number(button.dataset.galleryStep));
      }));
      const form = root.querySelector('.m-product-form');
      if (!form) return;
      const quantity = form.querySelector('[name=quantity]');
      form.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
        quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(button.dataset.quantity));
        quantity.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      form.querySelectorAll('[name=selling_plan]').forEach(input => input.addEventListener('change', () => {
        if(input.checked) root.querySelector('[data-product-price]').textContent = input.dataset.price;
      }));
      const selector = form.querySelector('select[name=id]');
      selector?.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('variant', selector.value);
        url.searchParams.delete('selling_plan');
        location.assign(url.href);
      });
      form.addEventListener('submit', async event => {
        if (!window.fetch || !FormData) return;
        event.preventDefault();
        const button = form.querySelector('[name=add]');
        if(button.disabled) return;
        const status = form.querySelector('.m-cart-status');
        const success = form.querySelector('.m-cart-success');
        button.disabled = true;
        form.setAttribute('aria-busy','true');
        status.textContent = '';
        success.hidden = true;
        const base = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const response = await fetch(`${base}cart/add.js`, {method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || root.dataset.cartError);
          added = true;
          success.hidden = false;
          const cartResponse = await fetch(`${base}cart.js`,{headers:{'Accept':'application/json'}});
          if(cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
          }
          success.querySelector('a')?.focus();
        } catch(error) {
          if(!added) status.textContent = error.message || root.dataset.cartError;
        } finally { button.disabled = false; form.removeAttribute('aria-busy'); }
      });
    });
    const popup = document.querySelector('#mana-signup-dialog');
    if(popup && !popup.dataset.bound) {
      popup.dataset.bound = 'true';
      let dismissed = false;
      try { dismissed = !!localStorage.getItem('mana-newsletter-dismissed') || !!sessionStorage.getItem('mana-newsletter-shown'); } catch {}
      popup.addEventListener('close', () => { try { localStorage.setItem('mana-newsletter-dismissed',String(Date.now())); } catch {} });
      if(!dismissed && !location.pathname.includes('/cart') && !location.pathname.includes('/contact') && !location.search.includes('customer_posted')) {
        setTimeout(() => {
          if (document.visibilityState === 'visible' && window.scrollY > 600 && !document.querySelector('dialog[open]') && !window.Shopify?.designMode) {
            popup.showModal();
            try { sessionStorage.setItem('mana-newsletter-shown','1'); } catch {}
          }
        },45000);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mana-home-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
 const patchNavigation=()=>{
  const destinations={'OUR STORY':'/pages/our-story','FAQ':'/pages/faq','RECIPES':'/pages/recipes','FARMERS MARKETS':'/pages/farmers-market','SHOP':'/pages/mana-burst'};
  document.querySelectorAll('#header-group a,#Details-menu-drawer-container a').forEach(link=>{
   const destination=destinations[link.textContent.trim().toUpperCase()];
   if(destination)link.setAttribute('href',destination);
  });
  const themeId=document.body.dataset.manaThemeId;
  if(themeId && document.body.dataset.manaThemeRole!=='main'){
   document.querySelectorAll('a[href]').forEach(link=>{
    const raw=link.getAttribute('href');
    if(!raw || raw.startsWith('#'))return;
    try{
     const url=new URL(raw,location.origin);
     if(url.origin!==location.origin || !/^\/(?:$|pages\/|products\/|collections\/|blogs\/|policies\/|cart$|search$)/.test(url.pathname))return;
     url.searchParams.set('preview_theme_id',themeId);
     link.setAttribute('href',url.pathname+url.search+url.hash);
    }catch{}
   });
  }
 };
 const bindHeaderScroll=()=>{
  if(!document.body.classList.contains('m-native') || document.body.dataset.manaScrollBound)return;
  document.body.dataset.manaScrollBound='true';
  let frame=0;
  const update=()=>{
   frame=0;
   const header=document.getElementById('header-component');
   if(!header)return;
   const top=Math.max(window.scrollY,document.scrollingElement?.scrollTop||0,document.querySelector('.page-wrapper')?.scrollTop||0);
   header.dataset.manaScrolled=String(top>24);
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
  document.addEventListener('scroll',schedule,{passive:true,capture:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);
  update();
 };
 const init=(scope=document)=>{
  scope.querySelectorAll('.__mana details').forEach(item=>{
   if(item.dataset.nativeBound)return;
   item.dataset.nativeBound='true';
   item.addEventListener('toggle',()=>{
    item.classList.toggle('open',item.open);
    item.querySelector('[data-mana-kind="Accordion3.Header"]')?.setAttribute('data-active',String(item.open));
    if(item.open)item.parentElement.querySelectorAll('details').forEach(other=>{if(other!==item)other.open=false});
   });
  });
  patchNavigation();
  bindHeaderScroll();
  const header=document.getElementById('header-group');
  if(header && !header.dataset.manaNavigationBound){
   header.dataset.manaNavigationBound='true';
   new MutationObserver(patchNavigation).observe(document.body,{childList:true,subtree:true});
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
